module.exports = __webpack_public_path__ + "img/[篮球].a15ae2f8.svg";